import { breakpoint } from '@/helpers/BreakpointHelper';
import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

export const BANNER_DISP_LOC_CD__DONATE_S1 = 'donor_step_1';
export const BANNER_DISP_LOC_CD__DONATE_S2 = 'donor_step_2';
export const BANNER_DISP_LOC_CD__DONATE_S3 = 'donor_step_3';

export interface BannerInfoData {
  indexNumber: string;
  supportModuleCode?: string; // 후원모듈배너
  scIndexNumber?: string; // 후원코드배너
  bnMessage: string;
  attGrpNoPcBanner: string;
  attGrpNoMoBanner: string;
  attGrpNoPcBannerFullpath: string;
  attGrpNoMoBannerFullpath: string;
  bnDispLoc: string;
}
interface DonateBannerProps {
  bannerinfo?: BannerInfoData;
  children: JSX.Element | JSX.Element[];
}

const DonateBannerContainer = styled.div`
  width: 384px;
  height: 64px;
  background-color: #e8ecef;
  margin-left: auto;
  padding: 10px 14px;
  position: relative;
  font-size: 15px;
  font-weight: 700;
  color: #1cabe2;
  line-height: 1.3;
  position: relative;

  .step2_img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    right: 0;
    &.mobile {
      display: none;
    }
  }

  span {
    position: relative;
    z-index: 2;
  }

  ${breakpoint(`mobile`)} {
    width: 15.2rem;
    height: 60px;
    span {
      font-size: 13px;
    }
    .step2_img {
      &.pc {
        display: none;
      }
      &.mobile {
        display: block;
      }
    }
  }
`;

const DonateBanner: FC<DonateBannerProps> = React.memo(
  ({ bannerinfo }, key) => {
    return (
      <>
        {bannerinfo?.bnMessage && (
          <DonateBannerContainer key={`bn-${key}`}>
            <span>
              {bannerinfo.bnMessage.split('\\n').map((line, idx) => {
                return (
                  <span key={idx}>
                    {line}
                    <br />
                  </span>
                );
              })}
            </span>
            <img
              src={bannerinfo.attGrpNoPcBannerFullpath}
              alt=""
              className="step2_img pc"
            />
            <img
              src={bannerinfo.attGrpNoMoBannerFullpath}
              alt=""
              className="step2_img mobile"
            />
          </DonateBannerContainer>
        )}
      </>
    );
  },
);

export default DonateBanner;
